"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("config");
const React = require("react");
const somethingWentWrongImg = require("../../../images/v2/something_went_wrong.svg");
const Translate_1 = require("../Translate");
require("./UnsupportedEnvironment.scss");
class UnsupportedEnvironment extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("div", { className: "unsupported" },
            React.createElement("img", { src: somethingWentWrongImg }),
            React.createElement("div", { className: "textBox" },
                React.createElement("h1", null,
                    React.createElement(Translate_1.Translate, { i18n: "hdr_unsupported_browser_or_environment" })),
                React.createElement("p", null,
                    React.createElement(Translate_1.Translate, { i18n: "txt_unsupported_browser_or_environment" }))),
            React.createElement("form", { action: config_1.default.urls.paths.download, method: "get", target: "_blank" },
                React.createElement("button", { className: "learnMore", "data-tid": "learnMore", onClick: this.props.onLearnMoreButtonClick },
                    React.createElement(Translate_1.Translate, { i18n: "hdr_btn_learn_more" })))));
    }
}
exports.UnsupportedEnvironment = UnsupportedEnvironment;
